// client/src/components/auth/Login.js
import React, { useState } from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuthMutations } from '../../hooks/useAuth';
import { useAuth } from '../../context/auth/AuthProvider';
import { Loader2, LogIn, Mail, Lock, Eye, EyeOff } from 'lucide-react';
import AuthShell from './AuthShell';
import AuthInput from './AuthInput';

const Login = () => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    const { login } = useAuthMutations();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        rememberMe: true
    });
    const [validationErrors, setValidationErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });

        if (validationErrors[name]) {
            setValidationErrors({
                ...validationErrors,
                [name]: null
            });
        }
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.email) {
            errors.email = 'Email é obrigatório';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = 'Email inválido';
        }

        if (!formData.password) {
            errors.password = 'Senha é obrigatória';
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        login.mutate(formData);
    };

    const isLoading = login.isPending;

    if (isAuthenticated) {
        const from = location.state?.from?.pathname || '/';
        return <Navigate to={from} replace />;
    }

    return (
        <AuthShell tagline="Acesse sua conta na plataforma">
            <form onSubmit={handleSubmit} noValidate>
                <AuthInput
                    icon={Mail}
                    label="Email"
                    id="email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    autoComplete="username"
                    disabled={isLoading}
                    placeholder="seuemail@exemplo.com"
                />
                {validationErrors.email && <p className="form-error">{validationErrors.email}</p>}

                <AuthInput
                    icon={Lock}
                    label="Senha"
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    autoComplete="current-password"
                    disabled={isLoading}
                    placeholder="Sua senha"
                    rightElement={
                        <button type="button" onClick={() => setShowPassword((v) => !v)} tabIndex={-1}>
                            {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                    }
                />
                {validationErrors.password && <p className="form-error">{validationErrors.password}</p>}

                <div className="auth-shell-forgot">
                    <Link to="/forgot-password">Esqueceu a senha?</Link>
                </div>

                <button type="submit" className="auth-shell-submit" disabled={isLoading}>
                    {isLoading ? <Loader2 className="animate-spin" size={20} /> : <LogIn size={20} />}
                    <span>Entrar</span>
                </button>
            </form>
        </AuthShell>
    );
};

export default Login;
